import { HourglassEmptyTwoTone } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

export const EmptyContent = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "20vh",
      }}
    >
      <HourglassEmptyTwoTone />
      <Typography fontWeight={"bold"} sx={{ color: "#808D7C" }} variant="h6">
        No receipts available for the selected period.
      </Typography>
      <Typography fontWeight={"bold"} sx={{ color: "#5F6F65" }} variant="body1">
        Try to select period (from,to)
      </Typography>
    </Box>
  );
};
